import React, { useState } from "react";
import axios from "axios";
import config from "../config";
import FeatureCheckbox from "../components/FeatureCheckbox";

const AddNewDevotions = () => {
  const [title, setTitle] = useState("");
  const [message, setMessage] = useState("");
  const [addToFeature, setAddToFeature] = useState(false);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    let validationErrors = {};
    if (!title.trim()) validationErrors.title = "Devotion Title is required";
    if (!message.trim()) validationErrors.message = "Devotion Message is required";

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return; // don't submit
    }

    setLoading(true);
    setErrors({});

    try {
      // Prepare post data for API (catId is example, update as needed)
      const postData = {
        catId: 2, // or dynamically get this from somewhere
        prayerType: "devotion", // this is devotion here
        title: title,
        description: message,
        reference: null,
        numberOfTask: null,
        file: null,
        isFeatured: addToFeature,
      };

      const response = await axios.post(
        `${config.BASE_URL}/apis/create-post-admin`,
        postData
      );

      if (response.data.success) {
        alert("Devotion created successfully!");
        setTitle("");
        setMessage("");
        setAddToFeature(false);
      } else {
        alert("Failed to create devotion: " + response.data.message);
      }
    } catch (error) {
      console.error(error);
      alert("An error occurred while creating devotion.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-4xl mx-auto mt-10 bg-white shadow-md rounded-md">
      {/* Header */}
      <div className="bg-orange-500 text-white px-4 py-3 rounded-t-md">
        <h2 className="font-semibold">Add New Devotion</h2>
      </div>

      {/* Form */}
      <div className="p-6">
        <form onSubmit={handleSubmit} noValidate>
          {/* Devotion Title */}
          <div className="mb-4">
            <label htmlFor="title" className="block text-gray-700 font-medium mb-1">
              Devotion Title
            </label>
            <input
              id="title"
              type="text"
              placeholder="Enter Devotion Title"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              className={`w-full border rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-orange-400 ${
                errors.title ? "border-red-500" : "border-gray-300"
              }`}
              required
              disabled={loading}
            />
            {errors.title && (
              <p className="text-red-500 text-sm mt-1">{errors.title}</p>
            )}
          </div>

          {/* Devotion Message */}
          <div className="mb-6">
            <label htmlFor="message" className="block text-gray-700 font-medium mb-1">
              Devotion Message
            </label>
            <textarea
              id="message"
              placeholder="Enter Devotion Message"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              className={`w-full border rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-orange-400 resize-none ${
                errors.message ? "border-red-500" : "border-gray-300"
              }`}
              rows={4}
              required
              disabled={loading}
            />
            {errors.message && (
              <p className="text-red-500 text-sm mt-1">{errors.message}</p>
            )}
          </div>

          <div className="flex flex-wrap items-center justify-between gap-4">
            <FeatureCheckbox checked={addToFeature} onChange={setAddToFeature} disabled={loading} />
            <button
              type="submit"
              className={`bg-orange-500 text-white font-semibold px-6 py-2 rounded hover:bg-orange-600 transition ${
                loading ? "opacity-50 cursor-not-allowed" : ""
              }`}
              disabled={loading}
            >
              {loading ? "Submitting..." : "Add"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddNewDevotions;
